import { render, staticRenderFns } from "./Scoreboard.vue?vue&type=template&id=00f5ad72&scoped=true&"
import script from "./Scoreboard.vue?vue&type=script&lang=js&"
export * from "./Scoreboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00f5ad72",
  null
  
)

export default component.exports